import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { MasterBlockId } from 'src/shared/types/base-entity-interface'
import { BorderStyleEnum, BorderTypeEnum } from 'common/types/styleTypes'
import { generateBaseEntity } from 'src/shared/entities/utils/generate-base-entity'
import { LoginButtonInterface } from 'src/shared/types/entities/login-button-interface'
import { WebsiteSettingsTypographyTypeEnum } from 'src/shared/types/website-settings-types'

export const createLoginButton = (
  parentId: string,
  text: string,
  subText: string,
  masterBlockId?: MasterBlockId,
): LoginButtonInterface => {
  return {
    ...generateBaseEntity(EntityTypeEnum.LoginButton, parentId, masterBlockId),
    buttonType: WebsiteSettingsTypographyTypeEnum.SecondaryButton,
    iconClassNameBefore: '',
    iconClassNameAfter: '',
    textFontSize: 14,
    subTextFontSize: 12,
    textColor: 'rgb(24, 25, 28)',
    subTextColor: 'rgba(255,255,255,0.8)',
    backgroundColor: 'rgb(255, 255, 255)',
    alignSelf: 'center',
    text,
    subText,
    width: 'auto',
    boxShadow: 'none',
    mobileSubTextFontSize: 12,
    mobileTextFontSize: 14,
    mobileWidth: '100%',
    mobileAlignSelf: 'center',
    mobileBoxShadow: 'none',
    border: {
      color: 'rgb(200, 202, 208)',
      radius: {
        borderTopLeftRadius: 10,
        borderTopRightRadius: 10,
        borderBottomRightRadius: 10,
        borderBottomLeftRadius: 10,
      },
      style: BorderStyleEnum.solid,
      type: BorderTypeEnum.fullBorder,
      width: 1,
    },
    mobileBorder: {
      color: 'rgb(200, 202, 208)',
      radius: {
        borderBottomLeftRadius: 10,
        borderBottomRightRadius: 10,
        borderTopLeftRadius: 10,
        borderTopRightRadius: 10,
      },
      style: BorderStyleEnum.solid,
      type: BorderTypeEnum.fullBorder,
      width: 1,
    },
    padding: {
      paddingBottom: 6,
      paddingTop: 6,
      paddingLeft: 12,
      paddingRight: 12,
    },
    mobilePadding: {
      paddingTop: 5,
      paddingRight: 5,
      paddingBottom: 5,
      paddingLeft: 5,
    },
    hover: {
      backgroundColor: 'rgb(255, 255, 255)',
    },
  }
}
